import { ReactComponent as FlagIcon } from "./svg/sv-flag.svg";
import "../flag-icon.scss";

export const SVFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
